import { createAsyncThunk, } from "@reduxjs/toolkit";
import { firstContributionForToday } from "src/helpers";
import GoalType from "src/models/GoalType";
import { RootState } from "src/store";
import { auth } from "src/authentication/firebase";
import apiServices from "src/api/apiService";


export const updateDailies = createAsyncThunk<any>('goals/daily', async (_, { getState, rejectWithValue }) => {
  const currentState = getState() as RootState; // Access the current state
  const dailyGoals = currentState.dailies.goals.filter((goal) => goal.type === GoalType.DailyBased);
  const dailyGoalsToApi = dailyGoals.map((g) => { return { "goalId": g.id, "contributorId": "lionel", "isDone": firstContributionForToday(g) ? true : false } });
  const user = auth.currentUser;
  if (!user) {
    throw new Error('No user is signed in');
  }
  //TODO: get this from the auth slice instead.
  const token = await user.getIdToken();
  try {
    const data = await apiServices.goal.updateDailies(token, dailyGoalsToApi);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

// Create a thunk for fetching goals
export const getGoals = createAsyncThunk<any>('goals/getGoals', async (_, {getState, rejectWithValue}) => {
  const currentState = getState() as RootState;

    

    const user = auth.currentUser;
    if (!user) {
      throw new Error('No user is signed in');
    }
     //TODO: get this from the auth slice instead.
    const token = await user.getIdToken();

    try {
      const data = await apiServices.goal.getGoals(token);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  });



